import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import Modal from "../modal/modal";
import Typography from "../typography/typography";
import TextField from "../text-field/text-field";
import Button from "../button/button";
import { FolderSave } from "../icons";

interface SaveFilter {
  open: boolean;
  onClose: () => void;
  handleSubmit: (name: string) => void;
  oldName?: string;
}

const SaveFilterModal = ({
  open,
  onClose,
  handleSubmit,
  oldName,
}: SaveFilter) => {
  const [name, setName] = useState<string>("");

  useEffect(() => {
    if (oldName !== undefined) {
      setName(oldName);
    }
  }, [oldName]);

  const handleSave = async (name: string) => {
    if (name) {
      const saved = await handleSubmit(name);

      if(saved) {
        setName("");
        onClose();
      }
    }

  };

  return (
    <>
      <Modal fullWidth onClose={onClose} open={open}>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap:0.5 }}>
            <FolderSave sx={{ fontSize: '1.25rem'}}/>
            <Typography type="s2" weight="medium" color={"theme.secondary.1000"}>
              Save active filters
            </Typography>
          </Box>
          <IconButton edge="end" onClick={onClose} size="small">
            <Close fontSize="inherit" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Name"
            fullWidth
            placeholder="Name Filter"
            value={name}
            onChange={(e: any) => setName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={onClose}
            style={{
              color: "black",
            }}
          >
            Cancel
          </Button>
          <Button onClick={() => handleSave(name)}>
            {oldName ? "Rename" : "Save"}
          </Button>
        </DialogActions>
      </Modal>
    </>
  );
};

export { SaveFilterModal };
export default SaveFilterModal;
